import React from 'react';

interface StatusBadgeProps {
  status: string; // 0 = stopped, 1 = running
}

export const StatusBadge: React.FC<StatusBadgeProps> = ({ status }) => {
  const isRunning = status === 'RUNNING';
  return (
    <span
      className={`inline-flex items-center gap-1.5 px-2.5 py-0.5 rounded-full text-xs font-medium ${
        isRunning
          ? 'bg-emerald-50 text-emerald-700'
          : 'bg-gray-100 text-gray-500'
      }`}
    >
      <span
        className={`w-1.5 h-1.5 rounded-full ${
          isRunning ? 'bg-emerald-500 animate-pulse' : 'bg-gray-400'
        }`}
      />
      {isRunning ? 'Running' : 'Stopped'}
    </span>
  );
};